import {env} from '../config/environment';
import {getPalette} from './palettes';
import {getLogo, hasMainLogo, hasNavBarLogo} from './logos';

// IMPORTANT: brand texts are kept in i18n locales in specific json
export const brand = {
    colors: getPalette(env.clientTheme),
    logo: getLogo(env.clientTheme),
    hasMainLogo: hasMainLogo(env.clientTheme),
    hasNavBarLogo: hasNavBarLogo(env.clientTheme),
};